// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"41bf43d1","496":"b61c4eec","542":"53ec8bca","553":"c58aa897","850":"9f4e2943","970":"fc7a33bb"}[chunkId] + ".chunk.js";
};